import { Injectable, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthServiceBackend } from '@serviceBackend';
import { AuthDTO, AuthLoginDTO, AuthRegisterDTO, UserDTO } from '@shared/dtos';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { UserService } from './user.service';

const TOKEN_KEY = 'token';
const USER_KEY = 'user';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private _token = "";
  private _user_id = "";

  public token = new BehaviorSubject<string>("");
  public user = new BehaviorSubject<UserDTO>(null);

  public get user_id() {
    return this._user_id;
  }
  
  constructor(private serviceBackend: AuthServiceBackend, private userService: UserService, private router: Router) {
    this._token = localStorage.getItem(TOKEN_KEY) || "";
    const data = JSON.parse(localStorage.getItem(USER_KEY));
    const user_id = data?.localId;
  
    if (!user_id) {
      this.logout();
    } else {
      this._user_id = user_id;
      this.getUserData(user_id);
    }

    this.token.next(this._token);
  }

  private async getUserData(idUser: string) {
    const users = await this.userService.getUser(idUser);
    if (users.length > 0) {
      this.user.next(users[0]);
    }
  }

  public async login(auth: AuthLoginDTO): Promise<boolean> {
    const authDTO = await firstValueFrom(this.serviceBackend.login(auth));

    if (authDTO == null) {
        return false;
    }

    this._token = authDTO.idToken;
    this._user_id = authDTO.localId;
    
    this.getUserData(authDTO.localId);
    this.saveUserData(authDTO);

    return true;
  }

  public async register(auth: AuthRegisterDTO, firstName: string, lastName: string): Promise<boolean> {
    const authDTO = await firstValueFrom(this.serviceBackend.register(auth));

    if (authDTO == null) {
        return false;
    }

    this._token = authDTO.idToken;
    this._user_id = authDTO.localId;

    const user = new UserDTO(authDTO.localId, firstName, lastName, auth.email);
    await this.userService.createUser(user);
    
    this.user.next(user)
    this.saveUserData(authDTO);

    return true; 
  }

  public logout() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    this._token = "";
    this._user_id = "";
    this.user.next(null);
    this.token.next(this._token);
    this.router.navigate(['./account/login']);
    return;
  }

  private saveUserData(auth: AuthDTO) {
    localStorage.setItem(TOKEN_KEY, this._token);
    localStorage.setItem(USER_KEY, JSON.stringify(auth));
    this.token.next(this._token);
  }
}
